__turbopack_context__.v({
  "avatar": "jaarplanning-visual-module__K8Spdq__avatar",
  "board": "jaarplanning-visual-module__K8Spdq__board",
  "cardInner": "jaarplanning-visual-module__K8Spdq__cardInner",
  "cardInnerVisible": "jaarplanning-visual-module__K8Spdq__cardInnerVisible",
  "cardSlot": "jaarplanning-visual-module__K8Spdq__cardSlot",
  "cardSlotCollapsed": "jaarplanning-visual-module__K8Spdq__cardSlotCollapsed",
  "chatBubble": "jaarplanning-visual-module__K8Spdq__chatBubble",
  "chatBubbleHead": "jaarplanning-visual-module__K8Spdq__chatBubbleHead",
  "chatBubbleIn": "jaarplanning-visual-module__K8Spdq__chatBubbleIn",
  "chatName": "jaarplanning-visual-module__K8Spdq__chatName",
  "chatTime": "jaarplanning-visual-module__K8Spdq__chatTime",
  "checkbox": "jaarplanning-visual-module__K8Spdq__checkbox",
  "checkboxChecked": "jaarplanning-visual-module__K8Spdq__checkboxChecked",
  "checklistLabel": "jaarplanning-visual-module__K8Spdq__checklistLabel",
  "checklistLabelDone": "jaarplanning-visual-module__K8Spdq__checklistLabelDone",
  "checklistRow": "jaarplanning-visual-module__K8Spdq__checklistRow",
  "colExtra": "jaarplanning-visual-module__K8Spdq__colExtra",
  "cursor": "jaarplanning-visual-module__K8Spdq__cursor",
  "cursorClicking": "jaarplanning-visual-module__K8Spdq__cursorClicking",
  "cursorGlyph": "jaarplanning-visual-module__K8Spdq__cursorGlyph",
  "cursorVisible": "jaarplanning-visual-module__K8Spdq__cursorVisible",
  "elbow": "jaarplanning-visual-module__K8Spdq__elbow",
  "floatCard": "jaarplanning-visual-module__K8Spdq__floatCard",
  "floatCardHeader": "jaarplanning-visual-module__K8Spdq__floatCardHeader",
  "floatCardMeta": "jaarplanning-visual-module__K8Spdq__floatCardMeta",
  "floatCardName": "jaarplanning-visual-module__K8Spdq__floatCardName",
  "floatStack": "jaarplanning-visual-module__K8Spdq__floatStack",
  "nameText": "jaarplanning-visual-module__K8Spdq__nameText",
  "notifyIcon": "jaarplanning-visual-module__K8Spdq__notifyIcon",
  "row": "jaarplanning-visual-module__K8Spdq__row",
  "rowName": "jaarplanning-visual-module__K8Spdq__rowName",
  "rowTag": "jaarplanning-visual-module__K8Spdq__rowTag",
  "rowsBody": "jaarplanning-visual-module__K8Spdq__rowsBody",
  "statSub": "jaarplanning-visual-module__K8Spdq__statSub",
  "stats": "jaarplanning-visual-module__K8Spdq__stats",
  "tableGrid": "jaarplanning-visual-module__K8Spdq__tableGrid",
  "urenAmount": "jaarplanning-visual-module__K8Spdq__urenAmount",
  "urenBooked": "jaarplanning-visual-module__K8Spdq__urenBooked",
  "urenUnit": "jaarplanning-visual-module__K8Spdq__urenUnit",
  "urenValue": "jaarplanning-visual-module__K8Spdq__urenValue",
});
